export const PORTFOLIO_HISTORY_TAB_IDS = [
  'trades',
  'deposits',
  'withdrawals',
  'transfers',
  'pools',
  'vlp',
  'liquidations',
  'settlements',
  'trigger_orders',
  'realized_pnl_events',
  'pnl_accounting_events',
] as const;
